import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/site';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="bg-[#FFFDF6] py-20 lg:py-28" data-id="element-11" data-mp="1lb906v27lci0">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-12" data-mp="1l9o3aysf9hgz">
        <div data-id="element-13" data-mp="1gauqz9ovfwie">
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#0B1B2B]/50" data-id="element-14" data-mp="2e0fvzmaa3nzk">
            FAQ
          </p>
          <h2 className="mt-3 text-4xl font-black leading-[1.02] tracking-tight text-[#0B1B2B] sm:text-5xl" data-id="element-15" data-mp="2913bv9askv0o">
            Good questions, straight answers.
          </h2>
          <p className="mt-4 text-lg text-[#0B1B2B]/70" data-id="element-16" data-mp="1z372alxi684o">
            Still wondering about something? Ask us in the quote form and we'll answer
            before you commit to anything.
          </p>
        </div>

        <ul className="divide-y-2 divide-[#0B1B2B]/10 border-y-4 border-[#0B1B2B]" data-id="element-17" data-mp="nnighxvzjf5g">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-18" data-mp="ugr3whef88fa" data-mpi={index}>
                <h3 data-id="element-19" data-mp="ufzgvuyw3j0m">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-20" data-mp="ug9b5uqywcc4">
                    <span className="text-lg font-extrabold text-[#0B1B2B] sm:text-xl" data-id="element-21" data-mp="biolwmkajbqz">
                      {faq.q}
                    </span>
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-[#0B1B2B] bg-[#FFD84D] text-[#0B1B2B]" data-id="element-22" data-mp="3t07u88cf1o6c">
                      {isOpen ? <Minus className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="3jyi2t2ijap8k" /> : <Plus className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="3nz1ys2rdfmt4" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="pb-6 pr-14" data-id="element-25" data-mp="1ppcnndtzql88">
                    <p className="text-base leading-relaxed text-[#0B1B2B]/75" data-id="element-26" data-mp="1kq9scl3tbtdg">{faq.a}</p>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}